import RoomTabContent from '../components/RoomTabContent';
import { Tabs, Tab } from 'react-bootstrap';
import amenity1 from '../assets/amenity1.png'
import amenity2 from '../assets/amenity2.png'
import amenity3 from '../assets/amenity3.png'
import amenity4 from '../assets/amenity4.png'
import amenity5 from '../assets/amenity5.png'
import premium1 from '../assets/premium1.png';
import premium2 from '../assets/premium2.png';
import premium3 from '../assets/premium3.png';
import premium4 from '../assets/premium4.png';
import premium5 from '../assets/premium5.png';
import family1 from '../assets/family1.png';
import family2 from '../assets/family2.png';
import family3 from '../assets/family3.png';
import family4 from '../assets/family4.png';
import family5 from '../assets/family5.png';
import elite1 from '../assets/elite1.png';
import elite2 from '../assets/elite2.png';
import elite3 from '../assets/elite3.png';
import elite4 from '../assets/elite4.png';
import elite5 from '../assets/elite5.png';
import NavbarComponent from '../components/Navbar';
import Footer from '../components/Footer';
import { useSearchParams } from 'react-router-dom';

const Room = () => {

    const [searchParams] = useSearchParams();
    const defaultTab = searchParams.get("tab") || "1";

    const sharedAmenities = [
        { icon: amenity1, label: 'Wifi in lobby' },
        { icon: amenity1, label: 'Wifi in rooms' },
        { icon: amenity2, label: 'CCTV' },
        { icon: amenity3, label: 'Fire Extinguishers' },
        { icon: amenity4, label: 'Parking' },
        { icon: amenity5, label: 'Roof Top Dinning' },
    ];

    return (
        <>
            <NavbarComponent />
            <div className="container mt-5">
                <Tabs defaultActiveKey={defaultTab} className="mb-3" justify>
                    <Tab eventKey="1" title="Premium Room">
                        <RoomTabContent
                            title="Premium Room"
                            tags={['Luxury', 'Nature view', 'Top rating']}
                            images={[premium1, premium2, premium3, premium4, premium5]}
                            description="Experience luxury in the hills with our premium room offering panoramic views of Kodaikanal’s misty valleys. Elegantly designed with polished wooden floors, plush bedding, and ambient lighting for ultimate comfort. Floor-to-ceiling windows open to a private balcony where clouds greet you each morning. Modern amenities blend seamlessly with nature-inspired interiors for a sophisticated retreat. Perfect for couples or solo travelers seeking a blend of tranquillity, charm, and high-end hospitality."
                            details={{ guests: '2 - Adults', square: '22 m²/237 ft²', bedrooms: 'Bedrooms', view: 'Outdoor View' }}
                            amenities={sharedAmenities}
                            checkIn="12 : 00 pm"
                            checkOut="10 : 00 am"
                        />
                    </Tab>

                    <Tab eventKey="2" title="Family Room">
                        <RoomTabContent
                            title="Family Room"
                            tags={['Luxury', 'Nature view', 'Top rating']}
                            images={[family1, family2, family3, family4, family5]}
                            description="Experience luxury in the hills with our Family Room offering panoramic views of Kodaikanal’s misty valleys. Elegantly designed with polished wooden floors, plush bedding, and ambient lighting for ultimate comfort. Floor-to-ceiling windows open to a private balcony where clouds greet you each morning. Modern amenities blend seamlessly with nature-inspired interiors for a sophisticated retreat. Perfect for couples or solo travelers seeking a blend of tranquillity, charm, and high-end hospitality."
                            details={{ guests: '5  Members ', square: '26 Sqft', bedrooms: '2 - Bedrooms', view: 'Outdoor View' }}
                            amenities={sharedAmenities}
                            checkIn="12 : 00 pm"
                            checkOut="10 : 00 am"
                        />
                    </Tab>

                    <Tab eventKey="3" title="Elite Room">
                        <RoomTabContent
                            title="Elite Room"
                            tags={['Luxury', 'Nature view', 'Top rating']}
                            images={[elite1, elite2, elite3, elite4, elite5]}
                            description="Experience luxury in the hills with our Elite Room offering panoramic views of Kodaikanal’s misty valleys. Elegantly designed with polished wooden floors, plush bedding, and ambient lighting for ultimate comfort. Floor-to-ceiling windows open to a private balcony where clouds greet you each morning. Modern amenities blend seamlessly with nature-inspired interiors for a sophisticated retreat. Perfect for couples or solo travelers seeking a blend of tranquillity, charm, and high-end hospitality."
                            details={{ guests: '2 - Adults', square: '26 Sqft', bedrooms: 'Bedrooms', view: 'Outdoor View' }}
                            amenities={sharedAmenities}
                            checkIn="12 : 00 pm"
                            checkOut="10 : 00 am"
                        />
                    </Tab>
                </Tabs>
            </div>
            <Footer />
        </>
    );
};

export default Room;
